import { generatePath } from 'react-router-dom';
import {
  ADMIN_ORGANIZATIONS_PATHS,
  ADMIN_PATH,
  ADMIN_SCHOOLS_PATHS,
  ADMIN_TAB_PATHS
} from '../../constants/paths.constants';

export const ADMIN_SCHOOL_MANAGEMENT_RESOURCE = {
  key: 'ADMIN_SCHOOL_MANAGEMENT_RESOURCE',
  getDetailPath: (data) => {
    return generatePath(
      `${ADMIN_PATH}${ADMIN_TAB_PATHS.ORGANIZATIONS.path}${ADMIN_ORGANIZATIONS_PATHS.SCHOOLS.path}${ADMIN_SCHOOLS_PATHS.COMMUNITIES.path}`,
      { netId: data.netId, managementId: data.id }
    );
  },
  table: {
    title: 'Schoolbesturen',
    defaultSort: 'name',
    dataLocation: '_embedded.schoolManagements.result',
    metaLocation: '_embedded.schoolManagements.meta',
    disablePagination: true,
    searchParams: ['name'],
    fields: [{ value: 'name', label: 'Naam', show: true, order: 0 }],
    dataTransform: (data, meta) => data?.map((i) => ({ ...i, name: i?.spoEntityData?.agodi?.name, netName: 'test' }))
  },
  api: {
    get: () => {
      throw new Error('replace api.get for ADMIN_SCHOOL_MANAGEMENT_RESOURCE');
    }
  }
};
